import { MutationTree } from 'vuex';
import { StatisticState } from './types';

export const mutations: MutationTree<StatisticState> = {
  setPushStatisticDetail: (state, data) => {
    state.pushStatisticDetail = data
  },
  pushPushStatisticDetail: (state, data) => {
    state.pushStatisticDetail = state.pushStatisticDetail?.concat(data)
  },
  setPushStatisticGroup: (state, data) => {
    state.pushStatisticGroup = data;
  },
  setPushSubscribers: (state, data) => {
    state.pushSubscribers = data;
  },
  setPushHistories: (state, data) => {
    state.pushHistories = data;
  },
};